import {useEffect, useState} from 'react';
import {useNavigate} from "react-router-dom";

import NavigationHeader from "../Layout/NavigationHeader";
import {getGameLibrary} from "../../common/BackendConnections";

function searchStringInArray (str, strArray) {
  for (let j=0; j<strArray.length; j++) {
    if (strArray[j].match(str)) return j;
  }
  return -1;
}

const GameLibraryCategory = props =>{
  return (
    <div  className={"mb-4"}>
      <label className={"mb-1"}>{props.name}</label>
      <div style={{display:"flex", flexWrap: "wrap"}}> {
          props.games.filter((game) => {
            return (!props.gameFilter) ?
              (game.categories.includes(props.name)) :
              (game.categories.includes(props.name) && game.tags.includes(props.gameFilter))
          }).map((game, g_index) => {
            return <GameLibraryItem key={g_index}
                                    onItemClick={props.handleGameButtonClick}
                                    name={game.name} id={game.scene_id}
                                    cover_img={game.cover_image}/>
          })
        }
      </div>
    </div>
  );
}

const GameLibraryItem = props => {
  return (
    <div className={"me-2 mb-3"}
         onClick={(e) => props.onItemClick(e, props.id)}
         style={{display: "block"}}>
      {/*<div style={{textAlign: "center", paddingLeft: ".5em", paddingRight: ".5em" }}>*/}
      {/*  {props.name}*/}
      {/*</div>*/}
      <div className={"image_gallery_item"} style={{textAlign: "center"}}>
        <img style={{height: "10em"}}
             src={props.cover_img ? props.cover_img: "/images/icons8-image-100.png"}
             alt={props.name}/>
      </div>
    </div>
  );
}

// ------
const GameLibraryPageContent = (props) => {
  const navigate = useNavigate();
  const [gameFilter, setGameFilter] = useState("");
  const [gameLibrary, setGameLibrary] = useState([]);

  useEffect(() => {
    getGameLibrary().then((response) => {
      const game_library = response.data["scene_list"];
      setGameLibrary(game_library);
    });
  }, []);

  // ----------------------------------------------------------------------------
  const handleGameButtonClick = (event, game_id) => {
    event.preventDefault();
    navigate("/game/" + game_id);
  };

  const category_set = new Set();
  for (let game of gameLibrary) {
    for (let category of game.categories) {
      category_set.add(category)
    }
  }
  const categories = Array.from(category_set);

  // ----------------------------------------------------------------------------
  return (
    <div className={"page_content"}>
      <NavigationHeader />

      <div>
        <h1>Game Library</h1>
        <div style={{marginTop:"1em", marginBottom:"5em"}}>
          <div className={"flex-row"}>
            <button className={(gameFilter === "")? "app-button-style2 active": "app-button-style2"}
                    onClick={() => setGameFilter("")}>
              All Games
            </button>
            <button className={(gameFilter === "VR")? "app-button-style2 active": "app-button-style2"}
                    onClick={() => setGameFilter("VR")}>
              Virtual Reality (VR)
            </button>
            <button className={(gameFilter === "Mobile")? "app-button-style2 active": "app-button-style2"}
                    onClick={() => setGameFilter("Mobile")}>
              Tablet
            </button>
          </div>
        </div>

        <div>
          {categories.map((category, c_index) => {
            return <GameLibraryCategory key={c_index}
                                         name={category}
                                         games={gameLibrary}
                                         gameFilter={gameFilter}
                                         handleGameButtonClick={handleGameButtonClick}
            />
          })}
        </div>
      </div>
    </div>
  );
}

export default GameLibraryPageContent;
